import { Extension } from '@tiptap/core'
import { Image } from '@tiptap/extension-image';


const editorUIStyles = `
  .image-upload-indicator {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 100;
  }

  .image-upload-indicator.show {
    display: block;
  }
`;

const ImageUploadExtension = Extension.create({

  name: 'imageUpload',

  addOptions () {
    return {
      uploadImage: (file) => {
        // default implementation for uploading the image
        return new Promise((resolve, reject) => {
          // simulate a delay of 2 seconds to upload the image
          setTimeout(() => {
            resolve({ url: URL.createObjectURL(file) })
          }, 2000)
        })
      },
      indicator: (props) => {
        // default implementation for displaying a progress indicator
        return `<div class="image-upload-indicator"></div>`
      }
    }
  },

  onCreate() {
    const editor = this.editor
    const root = editor.root

    console.log('created');

    root.addEventListener('drop', this.handleDrop.bind(this))
    root.addEventListener('paste', this.handlePaste.bind(this))

    // add CSS to style the progress indicator
    editor.ui.styles.add(editorUIStyles)
  },

  onDestroy() {
    const editor = this.editor
    const root = editor.root

    root.removeEventListener('drop', this.handleDrop.bind(this))
    root.removeEventListener('paste', this.handlePaste.bind(this))

    // remove the CSS when the extension is destroyed
    editor.ui.styles.remove(editorUIStyles)
  },

  handleDrop(event) {
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.uploadFiles(files)
    }
  },

  handlePaste(event) {
    const items = event.clipboardData.items
    const images = []
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile()
        images.push(file)
      }
    }
    if (images.length > 0) {
      this.uploadFiles(images)
    }
  },

  async uploadFiles(files) {
    const editor = this.editor
    const indicator = this.options.indicator

    const transaction = editor.view.state.tr
    const from = transaction.selection.from

    const imageNodes = []
    const uploadPromises = []

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const uploadPromise = this.options.uploadImage(file)

      uploadPromises.push(uploadPromise)

      const imageNode = editor.schema.nodes.image.create({
        attrs: {
          src: URL.createObjectURL(file),
          'data-placeholder': true,
        },
      })

      imageNodes.push(imageNode)
      transaction.insert(from, imageNode)
    }

    const uploadResults = await Promise.all(uploadPromises)

    uploadResults.then((results) => {
      console.log('the results', results);
    })

    for (let i = 0; i < uploadResults.length; i++) {
      const uploadResult = uploadResults[i]
      const imageNode = imageNodes[i]
      const { url } = uploadResult

      const transaction = editor.view.state.tr
      const imagePos = transaction.doc.content.findIndex(
        (node) => node === imageNode
      )

      const newAttrs = {
        src: url,
        'data-placeholder': false,
      }

      transaction.setNodeMarkup(imagePos, null, newAttrs)
      editor.view.dispatch(transaction)
    }
  }
});

export default ImageUploadExtension;